import React, { Component, Fragment } from 'react';
import { inject, observer } from 'mobx-react';
import isFunction from 'lodash/isFunction';
import pick from 'lodash/pick';

import { Spin } from 'antd';

import AirButton from '../../../../common/components/AirButton';
import AirModalTitlebar from '../../../../common/components/AirModalTitlebar';
import MapAddressRadius from '../MapAddressRadius';
import AirInput from '../../../../common/components/AirInput';
import AirRadioGroup from '../../../../common/components/AirRadioGroup';
import AirRadio from '../../../../common/components/AirRadio';

import './MapSavePOI.css';

@inject('translationsStore', 'poiStore')
@observer
export default class MapSavePOI extends Component {
  constructor(props) {
    super(props);

    this.defaultType = 'generic';
    this.typesData = [
      {
        key: 'garage',
        label: this.props.translationsStore.translate('poiTypes.base.garage')
      },
      {
        key: 'parking',
        label: this.props.translationsStore.translate('poiTypes.base.parking')
      },
      {
        key: 'generic',
        label: this.props.translationsStore.translate('poiTypes.base.generic')
      }
    ];

    this.state = {
      visibleModal: false,
      loading: false,
      countdown: 0,
      poiTitle: '',
      poiType: this.defaultType,
      poiAddress: '',
      poiToSave: {},
      poiRemoteCleared: false,
      poiRemoteError: ''
    };
  }

  componentWillUnmount = () => {
    clearInterval(this.countdownInterval);
  };

  clearCountdown = () => {
    clearInterval(this.countdownInterval);
    this.setState({ countdown: 0 });
  };

  onCountdownInterval = () => {
    this.setState(
      prevState => ({ countdown: --prevState.countdown }),
      () => {
        if (this.state.countdown === 0) {
          this.clearCountdown();
          this.handleHideModal();
        }
      }
    );
  };

  handleShowModal = () => {
    this.setState({ visibleModal: true });
  };

  handleHideModal = () => {
    this.setState({ visibleModal: false });
    this.clearCountdown();
  };

  onSave = () => {
    const { translationsStore, poiStore } = this.props;
    let { poiTitle: title, poiType: type, poiAddress: address } = this.state;
    title = title === '' ? translationsStore.translate('savePOIModal.POIForm.titleNotSet') : title;
    const musketeers = pick(this.props.poi, ['lat', 'lng', 'radius']);
    const POIToSave = { ...musketeers, position: { type: 'Point', coordinates: [musketeers.lng, musketeers.lat] }, radius: musketeers.radius, title, type, address };

    this.setState({ poiToSave: POIToSave, loading: true, poiRemoteCleared: false });
    poiStore
      .create(POIToSave)
      .then(response => {
        const { id } = response;
        const success = Number(id) > 0;
        if (success) {
          this.setState({ poiRemoteCleared: true, countdown: 30 });
          this.countdownInterval = setInterval(() => {
            this.onCountdownInterval();
          }, 1000);

          // this.handleHideModal();
          if (isFunction(this.props.onSave)) {
            this.props.onSave(POIToSave);
          }
        } else {
          console.log(response);
        }
      })
      .catch(err => {
        const errorMessage = err.message || err;
        this.setState({ poiRemoteError: errorMessage });
      })
      .finally(() => this.setState({ loading: false }));
  };

  onTitleChange = e => {
    this.setState({ poiTitle: e.target.value });
  };

  onTypeChange = e => {
    this.setState({ poiType: e.target.value });
  };

  onAddressFound = address => {
    this.setState({ poiAddress: address });
  };

  render() {
    const { translationsStore } = this.props;

    const addressRadiusData = { ...{ ...this.props.poi } };

    const labelOKButton = this.state.poiRemoteCleared
      ? `${translationsStore.translate('savePOIModal.labelClose')}${this.state.countdown > 0 ? ` [${this.state.countdown}]` : ''}`
      : translationsStore.translate('savePOIModal.labelSave');

    if (!(this.props.hasOwnProperty('visible') && !this.props.visible)) {
      return (
        <div className={`MapSavePOI ${this.props.className || ''}`} style={this.props.style}>
          <div className="Button ButtonOpenModal" onClick={this.handleShowModal}>
            {translationsStore.translate('mapMenu.savePOI.labelSave')}
          </div>
          <AirModalTitlebar
            className="SavePOIModal"
            visible={this.state.visibleModal}
            onCancel={this.handleHideModal}
            okButton={<AirButton disabled={this.state.loading} size="large" light label={labelOKButton} style={{ width: 240 }} />}
            onOk={this.state.poiRemoteCleared ? this.handleHideModal : !this.state.loading ? this.onSave : undefined}
            title={translationsStore.translate('savePOIModal.title')}
            titlebarStyle={{ color: 'white', backgroundColor: 'var(--yellow)' }}
            buttonsStyle={{ justifyContent: 'center' }}
            width={560}
          >
            <MapAddressRadius {...addressRadiusData} onAddressFound={this.onAddressFound} />
            <Spin spinning={this.state.loading}>
              {!this.state.poiRemoteCleared ? (
                <div className="POIForm">
                  <AirInput label={translationsStore.translate('savePOIModal.POIForm.labelTitle')} value={this.state.poiTitle} onChange={this.onTitleChange} />
                  <AirRadioGroup onChange={this.onTypeChange} value={this.state.poiType}>
                    {this.typesData.map((type, index) => (
                      <AirRadio key={index} label={type.label} value={type.key} />
                    ))}
                  </AirRadioGroup>
                </div>
              ) : (
                <div className="POISaved">
                  <div className="POISavedMessage">{translationsStore.translate('savePOIModal.POISaved.message')}</div>
                  <div className="POICell">
                    <div className="POICellLabel">{translationsStore.translate('savePOIModal.POISaved.labelTitle')}</div>
                    <div className="POICellValue">{this.state.poiToSave.title}</div>
                  </div>
                  <div className="POICell">
                    <div className="POICellLabel">{translationsStore.translate('savePOIModal.POISaved.labelType')}</div>
                    <div className="POICellValue">{translationsStore.translate(`poiTypes.base.${this.state.poiToSave.type}`)}</div>
                  </div>
                </div>
              )}
            </Spin>
          </AirModalTitlebar>
        </div>
      );
    } else {
      return <Fragment />;
    }
  }
}



// WEBPACK FOOTER //
// ./src/common/components/MapMenu/MapSavePOI/MapSavePOI.js